"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES = exports.UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const common_1 = require("@Const/common");
const clsx_1 = __importDefault(require("clsx"));
const contexts_1 = require("@App/contexts");
const UploadedDocumentsList_1 = __importDefault(require("@Components/OverclaimView/DocumentForms/UploadDocumentsForm/UploadedDocumentsList"));
const UploadDocumentsFormButtons_1 = __importDefault(require("@Components/OverclaimView/DocumentForms/UploadDocumentsForm/UploadDocumentsFormButtons"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const UploadDocumentConfirmationPopup_1 = __importDefault(require("@Components/Popups/UploadDocumentConfirmationPopup"));
exports.UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES = [
    '.docx',
    '.doc',
    '.csv',
    '.xls',
    '.xlsx',
    '.pdf',
    '.png',
    '.jpeg',
    '.jpg',
];
const UPLOAD_FILE_TYPES_STRING = exports.UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES.join(', ');
exports.UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES = 5 * 1024 * 1024;
const UploadDocumentsForm = ({ onDoneClicked }) => {
    const { popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [uploadedFiles, setUploadedFiles] = (0, react_1.useState)([]);
    const [filesWereUploaded, setFilesWereUploaded] = (0, react_1.useState)(false);
    const [dragOver, setDragOver] = (0, react_1.useState)(false);
    const [displayUploadDisclaimer, setDisplayUploadDisclaimer] = (0, react_1.useState)(false);
    const browseFilePickerRef = (0, react_1.useRef)(null);
    const combineUploadedFiles = (files) => {
        if (browseFilePickerRef.current) {
            const allFiles = [...Array.from(files), ...uploadedFiles];
            setUploadedFiles([...allFiles]);
        }
    };
    const onFilesChosen = (event) => {
        var _a;
        const files = event.target.files;
        if (files) {
            for (const file of files) {
                const fileExtension = (_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                if (!exports.UPLOAD_DOCUMENTS_FORM_ACCEPTED_FILE_TYPES.includes(`.${fileExtension}`)) {
                    popupStore.setAlertData('File type not supported', true);
                    return;
                }
                if (file.size > exports.UPLOAD_DOCUMENTS_FORM_MAX_FILE_SIZE_IN_BYTES) {
                    popupStore.setAlertData('File size should not exceed 5MB', true);
                    return;
                }
            }
            combineUploadedFiles(files);
        }
    };
    const resetForm = () => {
        setUploadedFiles([]);
        setFilesWereUploaded(false);
    };
    return (react_1.default.createElement("div", { className: 'upload-documentation-form' },
        react_1.default.createElement(ModalPortal_1.default, { isOpen: displayUploadDisclaimer },
            react_1.default.createElement(UploadDocumentConfirmationPopup_1.default, { onClose: () => setDisplayUploadDisclaimer(false), setFilesWereUploaded: (newFilesWereUploaded) => setFilesWereUploaded(newFilesWereUploaded), uploadedFiles: uploadedFiles })),
        react_1.default.createElement("h3", null, "Upload Documentation"),
        react_1.default.createElement("p", null, `Please select the file you want to upload. Your files should be in ${UPLOAD_FILE_TYPES_STRING} and not
                exceed 5MB in size.`),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('drag-and-drop-zone', dragOver && 'drag-over'), onDragOver: (event) => {
                event.preventDefault();
                if (!dragOver) {
                    setDragOver(true);
                }
            }, onDragLeave: (event) => {
                event.preventDefault();
                setDragOver(false);
            }, onDrag: (event) => {
                event.preventDefault();
            }, onDrop: (event) => {
                combineUploadedFiles(event.dataTransfer.files);
                event.preventDefault();
            } },
            react_1.default.createElement("div", { className: 'upload-center' },
                react_1.default.createElement("img", { src: common_1.ICONS.upload, alt: "upload" }),
                react_1.default.createElement("h3", null, "Drag & Drop Files Here")),
            react_1.default.createElement("span", { className: 'description' }, `${UPLOAD_FILE_TYPES_STRING} only. Files should not exceed 5MB in size.`)),
        react_1.default.createElement("label", { className: 'browse-files-label', htmlFor: 'browse-file-picker' }, "Browse Files"),
        react_1.default.createElement("input", { ref: browseFilePickerRef, id: 'browse-file-picker', className: 'browse-files-button', type: "file", name: "browse-files", multiple: true, onChange: onFilesChosen, hidden: true }),
        react_1.default.createElement("div", { className: "files-preview" }, uploadedFiles.length === 0 ? (react_1.default.createElement("p", null, "No files currently selected for upload")) : (react_1.default.createElement(UploadedDocumentsList_1.default, { uploadedFiles: uploadedFiles, filesWereUploaded: filesWereUploaded, setUploadedFiles: setUploadedFiles, browseFilePickerRef: browseFilePickerRef }))),
        filesWereUploaded && (react_1.default.createElement("b", { className: 'files-uploaded-confirmation-text' }, "Your files were successfully uploaded!")),
        react_1.default.createElement("div", { className: 'upload-files-button-container' },
            react_1.default.createElement(UploadDocumentsFormButtons_1.default, { onUploadClicked: () => setDisplayUploadDisclaimer(true), onResetClicked: resetForm, onDoneClicked: onDoneClicked, filesWereUploaded: filesWereUploaded, filesAreStaged: uploadedFiles.length > 0 }))));
};
exports.default = (0, mobx_react_1.observer)(UploadDocumentsForm);
